import type { SearchSuggestion } from '@silvertours/front-entities';
import type { RentalDirection } from '@silvertours/front-features/src/SearchFormLegacy';
import { SearchFormState } from 'frontend/features/src/SearchFormLegacy/context';
import { GENERIC_EVENT_NAME } from './constants';
import { GenericAnalyticsEvent } from './types';

const trackEvent = async (data: GenericAnalyticsEvent) => {
  if (typeof window === 'undefined') return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(data);
};

// Search Form/Wizzard Events
const trackEditLocationClick = (direction: RentalDirection) => {
  trackEvent({
    event: GENERIC_EVENT_NAME,
    name: 'edit_location_click',
    properties: { direction },
  });
};

const trackLocationSuggestionClick = (
  direction: RentalDirection | undefined,
  location: SearchSuggestion,
  suggestion_position: number,
) => {
  trackEvent({
    event: GENERIC_EVENT_NAME,
    name: 'location_suggestion_click',
    properties: {
      direction,
      location,
      suggestion_position,
    },
  });
};

const trackEditTravelDateClick = () => {
  trackEvent({
    event: GENERIC_EVENT_NAME,
    name: 'edit_travel_date_click',
    properties: {},
  });
};

const trackEditTimeClick = () => {
  trackEvent({
    event: GENERIC_EVENT_NAME,
    name: 'edit_time_click',
    properties: {},
  });
};

const trackDateRangeConfirmSelectionClick = (
  drop_off_date?: Date,
  pick_up_date?: Date,
) => {
  trackEvent({
    event: GENERIC_EVENT_NAME,
    name: 'date_range_confirm_selection_click',
    properties: { drop_off_date, pick_up_date },
  });
};

const trackEditDriverAgeClick = () => {
  trackEvent({
    event: GENERIC_EVENT_NAME,
    name: 'edit_driver_age_click',
    properties: {},
  });
};

const trackReturnOnDifferentLocationClick = (is_enabled: boolean) => {
  trackEvent({
    event: GENERIC_EVENT_NAME,
    name: 'return_on_different_location_click',
    properties: { is_enabled },
  });
};

const trackStartSearch = (search: SearchFormState | null) => {
  trackEvent({
    event: GENERIC_EVENT_NAME,
    name: 'start_search',
    properties: { ...search, source: 'landing_page' },
  });
};

// Account Events
const trackLogin = (payload: { userId?: string }) => {
  trackEvent({
    event: GENERIC_EVENT_NAME,
    name: 'login',
    properties: payload,
  });
};

const trackLogout = () => {
  trackEvent({
    event: GENERIC_EVENT_NAME,
    name: 'logout',
  });
};

export {
  trackLocationSuggestionClick,
  trackReturnOnDifferentLocationClick,
  trackDateRangeConfirmSelectionClick,
  trackEditLocationClick,
  trackEditDriverAgeClick,
  trackStartSearch,
  trackLogin,
  trackLogout,
  trackEditTravelDateClick,
  trackEditTimeClick,
};
